import { track } from "jiffy-analytics";
import ModalClass from "common/utils/ui/modal-class";

const updateOAuthLinksWithUuid = modalElement => {
  const uuid = modalElement.getAttribute("data-design-project-uuid");
  if (!uuid) return;

  const oauthLinks = modalElement.querySelectorAll(".js-oauth-link");
  oauthLinks.forEach(link => {
    if (link.href === "#" || !link.href) return;

    const url = new URL(link.href, window.location.origin);
    url.searchParams.set("design_project_uuid", uuid);
    link.setAttribute("href", url.pathname + url.search + url.hash);
  });
};

export default class SignInModalClass extends ModalClass {
  openModalCallback() {
    super.openModalCallback();
    track("sign_in_modal_opened");
    updateOAuthLinksWithUuid(this.$modal);
  }
}
